import { render, staticRenderFns } from "./AwsSaffronReport2.vue?vue&type=template&id=fab95e1e&"
import script from "./AwsSaffronReport2.vue?vue&type=script&lang=js&"
export * from "./AwsSaffronReport2.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports